import React, { useEffect, useState } from "react";
import axios from "axios";
import { GALLERY, IMAGES } from "../../data/content";
import { Reveal, SectionHeading } from "../shared/Primitives";
import { DotGrid, Sparkle } from "../shared/Decor";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const galleryUrl = (id) => `${BACKEND}/api/gallery/photos/${id}`;

// Patrón de composición actual (se conserva idéntico y se repite si hay más fotos).
const SPAN_PATTERN = [
  "lg:col-span-2 lg:row-span-2",
  "",
  "",
  "lg:row-span-2",
  "lg:col-span-2",
  "",
];

export const Gallery = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/gallery`)
      .then((r) => setItems(r.data?.photos || []))
      .catch(() => setItems([]));
  }, []);

  // Fuente de datos: fotos administradas o fallback a las actuales.
  const managed = items && items.length > 0;
  const list = managed
    ? items.map((p, i) => ({ src: galleryUrl(p.id), alt: p.alt || "", span: SPAN_PATTERN[i % SPAN_PATTERN.length] }))
    : GALLERY.map((g) => ({ src: IMAGES[g.src], alt: g.alt, span: g.span }));

  return (
    <section id="galeria" data-testid="gallery-section" className="relative overflow-hidden bg-linen py-16 sm:py-20 lg:py-28">
      <DotGrid className="absolute top-14 right-10 w-24 text-camel/30 hidden sm:block" />
      <Sparkle className="absolute top-28 left-6 w-8 text-cocoa/30 hidden lg:block" />
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 relative z-10">
        <SectionHeading
          overline="Así se vive aquí"
          title="Galería"
          subtitle="Un vistazo a los espacios donde la comunidad cobra vida."
        />

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 auto-rows-[180px] sm:auto-rows-[220px] lg:auto-rows-[240px] gap-4">
          {list.map((item, i) => (
            <Reveal key={i} delay={(i % 4) * 0.06} className={`${item.span} rounded-2xl overflow-hidden`}>
              <div data-testid={`gallery-item-${i}`} className="group relative w-full h-full overflow-hidden">
                <img
                  src={item.src}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-espresso/0 group-hover:bg-espresso/45 transition-colors duration-500 flex items-end">
                  {item.alt ? (
                    <span className="text-linen text-sm font-light tracking-wide p-5 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      {item.alt}
                    </span>
                  ) : null}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
